import { Helmet } from 'react-helmet';

import { microfrontendURLPrefix } from '@/config';
import ErrorPopin from '@components/ErrorPopin';
import { useNavigate } from 'react-router';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>List Manager - Page not found</title>
        <meta name="description" content="List Manager - Page not found" />
      </Helmet>
      <ErrorPopin
        title="The page cannot be found"
        message="The URL you requested does not exist"
        handler={() => {
          navigate(microfrontendURLPrefix || '/');
        }}
        button="Home"
      />
    </>
  );
};

export default NotFound;
